import { Component } from '@angular/core';

/**
 * This class represents the navigation bar component.
 */
@Component({
  selector: 'app-navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.css'],
})
export class NavbarComponent { }



// WEBPACK FOOTER //
// /ng-app/src/app/shared/navbar/navbar.component.ts